<template>
  <banner-component v-if="!loading" :banner-event-list="bannerEvents"></banner-component>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import BannerComponent from '@/components/BannerComponent.vue';

const loading = ref(true);
const store = useStore();

const nonRmsEvents = computed(() => store.getters.nonRmsEvents?.data ?? []);
const bannerEvents = computed(() =>
  nonRmsEvents.value.filter((event) => event.other.type == 'banner')
);

const updateNonRmsEvents = () => {
  loading.value = true;

  store
    .dispatch('getNonRmsEvents', { token: null })
    .then((response) => {
      if (!response) {
        console.error('Error reading non rms events');
      }

      loading.value = false;
    })
    .catch((error) => {
      console.error('BannersList::updateNonRmsEvents() -- error:', error);

      loading.value = false;
    });
};

onMounted(() => {
  updateNonRmsEvents();
});
</script>
